
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { MdPerson, MdRemove } from "@vicons/ionicons4";
import { useStore, mapGetters } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters,
  Params as ParticipationParams
} from "@/store/enums/participationEnums";
import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters
} from "@/store/enums/hosterEnums";
import { useThemeVars, useDialog } from "naive-ui";
import { changeColor } from "seemly";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply
} from "@/store/enums/paramsEnums";

import { eventResponse} from "@/core/models/share/voteEvent.interface";
import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import voteEventCountModel from "@/core/models/share/voteEventCount.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import voteEventCountI from "@/core/models/share/voteEventCount.interface";
import {
  Module as ExposedModule,
  Actions as ExposedActions,
  Mutations as ExposedMutations,
  Getters as ExposedGetters
} from "@/store/enums/exposedEnums";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "participantModalReplayListSortByStartTime",
  components: {
    MdPerson,
    MdRemove
  },
  props: {
    event: { type: Object as PropType<inviteEventModel | null> }
  },
  setup(props: any, context: any) {
    const store = useStore();
    const { t, locale } = useI18n();
    const personNone = computed(
      // () => store.getters[HosterModule.desc + HosterGetters.InvitMember]
      function() {
        let ori: Array<invitePersonModel> =
          store.getters[ExposedModule.desc + ExposedGetters.InvitMember];
        ori = ori.filter(
          (r: invitePersonModel) => r.Status == ParamParticapantStatus.None
        );

        // var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
        let name = ori.map((a: invitePersonModel) => a.Name).join(", ");
        let count = ori.length;

        return { name: name, count: count, data: ori };
      }
    );

    const personAll = computed(
      // () => store.getters[HosterModule.desc + HosterGetters.InvitMember]
      function() {
        let ori: Array<invitePersonModel> =
          store.getters[ExposedModule.desc + ExposedGetters.InvitMember];
        ori = ori.filter(
          (r: invitePersonModel) => r.Status == ParamParticapantStatus.All
        );

        // var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
        let name = ori.map((a: invitePersonModel) => a.Name).join(", ");
        let count = ori.length;

        return { name: name, count: count, data: ori };
      }
    );
    const resNone = computed<invitePersonModel>(
      () =>
        store.getters[ExposedModule.desc + ExposedGetters.EventPartRespStatus]
    );

    const eventResponse = computed<Array<voteEventModel>>(
      () => store.getters[ExposedModule.desc + ExposedGetters.EventResponse]
    );

    const responseGroupList = computed<
      Array<{ week: string;  checkAll: string; items: Array<voteEventCountModel> }>
    >(function() {
      // let currentWeek = 0;
      let ori: Array<voteEventCountModel> = store.getters[
        ExposedModule.desc + ExposedGetters.EventSchedularCountWithMyResponse
      ](ParticipationParams.SortByStartTime);
      // let result: Array<{ week: string; items: Array<voteEventCountModel> }> = [];
      let dayIndexArray: Array<{
        week: string;
        checkAll: string;
        items: Array<voteEventCountModel>;
      }> = [];
      // let idx = -1;
      // let dayIndexArray:any [] = [];
      ori.forEach(item => {
        let dayIndex: string = dayjs( item.ScheduleStartUTCDateTime).format(
          "YYYY-MM-DD (ddd)"
        );
        let duplicateFlag = false;
        dayIndexArray.forEach(item => {
          if (dayIndex === item["week"]) {
            duplicateFlag = true;
          }
        });
        if (!duplicateFlag) {
          dayIndexArray.push({
            week: dayIndex,
            checkAll: "Y",
            items: []
          });
        }
      });
      //console.log(dayIndexArray);
      dayIndexArray.forEach((dayIndex, index) => {
        // console.log(dayIndex);
        ori.forEach(item => {
          if (
            dayjs( item.ScheduleStartUTCDateTime).format("YYYY-MM-DD (ddd)") ===
            dayIndex["week"]
          ) {
            dayIndexArray[index]["items"].push(item);
            if (item.Status == "N"){
              dayIndexArray[index]["checkAll"] = "N"
            }
          }
        });
      });
      return dayIndexArray;
    });

    async function voteNone(resNone: invitePersonModel, status: string) {
      let param = {
        EventParticipantId: resNone.EventParticipantId,
        Status: status
      };

      await store.dispatch(
        ExposedModule.desc + ExposedActions.HandMyEventVoteNone,
        param
      );

      await store.dispatch(
        `${ExposedModule.desc}${ExposedActions.LoadExposed}`,
        { participatantId: param.EventParticipantId }
      );
    }

    async function userVote(
      evntId: string,
      timeId: string,
      usrId: string,
      resId: string,
      status: string
    ) {
      let param = {
        EventHeaderId: evntId,
        EventScheduleId: timeId,
        EventParticipantId: usrId,
        ParticipantResponseId: resId,
        Status: status
      };

      await store.dispatch(
        ExposedModule.desc + ExposedActions.HandMyEventVote,
        param
      );
      await store.dispatch(
        `${ExposedModule.desc}${ExposedActions.LoadExposed}`,
        { participatantId: param.EventParticipantId }
      );
    }

    async function userMultiVote(
      voteData: Array<voteEventCountI>, status: string
    ) {
      let voteDataNew: Array<eventResponse> = [];
      let voteDataUpdate: Array<eventResponse> = [];
      voteData.forEach(item => {
        if (item.ParticipantResponseId == null){
          voteDataNew.push({EventHeaderId: item.EventHeaderId, 
            EventScheduleId: item.EventScheduleId, 
            EventParticipantId: item.EventParticipantId, 
            Status: status})
        }
        else{
          voteDataUpdate.push({EventHeaderId: item.EventHeaderId, 
            ParticipantResponseId: item.ParticipantResponseId,
            EventScheduleId: item.EventScheduleId, 
            EventParticipantId: item.EventParticipantId, 
            Status: status})
        }
      })
      
      let param1 = {
        newVote: "Y",
        voteData: voteDataNew,
      };
      
      let param2 = {
        newVote: "N",
        voteData: voteDataUpdate,
      };

      if (param1.voteData.length > 0){
        await store.dispatch(
        ExposedModule.desc + ExposedActions.HandMyMultiEventVote,
        param1
      );
      }

      if (param2.voteData.length > 0){
        await store.dispatch(
        ExposedModule.desc + ExposedActions.HandMyMultiEventVote,
        param2
      );
      }

      voteData.forEach(item => {
        store.dispatch(
        `${ExposedModule.desc}${ExposedActions.LoadExposed}`,
        { participatantId: item.EventParticipantId }
      );
      })

    }
    
    function dateDisplay(date: string) {
      return dayjs( date).format("MM/DD ddd");
    }

    function startTimeDisplay(date: string) {
      return dayjs( date).format("HH:mm");
    }

    function endTimeDisplay(date: string) {
      return dayjs( date).format("HHmm") == "0000"
        ? "24:00"
        : dayjs( date).format("HH:mm");
    }

    function percentage(numerator: number, denominator: number) {
      return Number(((numerator * 100) / denominator).toFixed(0));
    }

    function eventResponseFilter(eventScheduleId: string) {
      var result = eventResponse.value.filter(
        (e: voteEventModel) =>
          e.EventScheduleId == eventScheduleId && e.Status != null
      );
      let name = result.map(a => a.Name).join(", ");
      return name;
    }

    onMounted(() => {});

    return {
      ParamResponseStatus,
      ParamParticapantStatus,
      responseGroupList,
      userVote,
      themeVars: useThemeVars(),
      changeColor,
      dateDisplay,
      startTimeDisplay,
      endTimeDisplay,
      percentage,
      voteNone,
      resNone,
      eventResponseFilter,
      personNone,
      t,
      personAll,
      userMultiVote
    };
  }
});
